<template>
  <div>
    <div v-if="isRecommendedNewArrivals">
      <TopSellingSection
        callerComp="new arrival"
        :renderName="renderName"
        :renderData="[...recommNewArrivalsData, renderData[renderData.length - 1]]"
      />
    </div>
    <div v-else-if="renderData && renderData.length && renderData.length > 1" class="newarrivalcard">
      <div class="newarrivalcard__title-cont">
        <h3 v-if="renderName" class="title" :class="!isDesktop ? 'text-left pl-4' : ''">{{renderName}}</h3>
        <p v-if="getDescription" class="descrition">{{getDescription}}</p>
      </div>
      <div class="headtop prelative top-banner">
        <carousel ref="my-carousel" :navigationEnabled="isDesktop"
        :paginationEnabled="false" navigationNextLabel=" " navigationPrevLabel=" "
        :loop="true" :autoplay="shouldAutoPlay" :speed="500" :autoplayTimeout="6000" class="bannerview"  :perPage="isDesktop ? 2 : 1"
        :perPageCustom="[[213, 1.3], [480, 1.3], [768, 1.3], [1200, 3], [1920, 4]]"
      >
        <slide v-for="(prm, index) in renderData.slice(0, renderData.length - 1)" :key="index"
          :class="isDesktop ? 'col-md-4 col-6' : 'custom-slide'">
          <router-link :to="getRedirectionUrl(prm)" role="link" class="card-container pointer" v-bannerImageLoad="getBannerImpressionData(prm, index)" :class="isDesktop ? null : 'm-1'" @click="getRedirectionLink(prm,index)">
            <div v-show="newArrivalShimmerLoading[index]">
                <NewArrivalPlaceholder :styleObject="childStyles"></NewArrivalPlaceHolder>
            </div>
            <img v-show="!newArrivalShimmerLoading[index]"  class="img-card customFade img-auto" :data-url="getBannerImage(prm.image)"
                :alt="prm.is_pdp ? prm.product_slug : prm.url"
                :title="prm.is_pdp ? prm.product_slug : prm.url"
                @load="onImageLoad(index)"
                @error="onImageError(index)"
                width="480"
                height="460"
              />
          </router-link>
        </slide>
      </carousel>
      </div>
    </div>
  </div>
</template>

<script>
var $ = require('jquery')
window.jQuery = $
import Vue from 'vue'
import {Carousel, Slide} from 'vue-carousel'
import {mapGetters} from 'vuex'
import TopSellingSection from './TopSellingSection.vue'
import {appMixins} from '../../assets/js/appMixins'
import {getProductUrl} from '../../assets/js/common'
import NewArrivalPlaceholder from './ShimmerEffectPlaceHolder.vue'
export default {
  mixins: [appMixins],
  data () {
    return {
      newArrivalShimmerLoading: [],
      imgPath: process.env.IMG_BASE_URL,
      childStyles: {
        width: '300px',
        height: '300px'
      }
    }
  },
  props: ['renderName', 'renderData', 'newArrival', 'widgetType'],
  components: {
    Carousel,
    Slide,
    TopSellingSection,
    NewArrivalPlaceholder
  },
  methods: {
    onImageLoad (index) {
      this.$set(this.newArrivalShimmerLoading, index, false)
    },
    onImageError (index) {
      this.$set(this.newArrivalShimmerLoading, index, true)
    },
    getRedirectionUrl (prm) {
      if (prm.is_pdp || prm.product_slug) {
        return `/product/${prm.product_slug}?gte=${prm.gender ? 2 : 1}`
      }
      return prm.url || ''
    },
    getRedirectionLink: function (prm, index) {
      let slide = {
        'index': index,
        'images': prm.image,
        'url': prm.is_pdp ? prm.product_slug : prm.url
      }
      const gender = Vue.ls.get('tss_landingCategory')
      this.$store.commit('GTAG_EVENT', {eventName: 'new_arrivals',
        payload: {
          slider_index: slide.index,
          url: slide.url,
          imageURL: slide.images
        }}
      )
      this.$store.commit('SET_NAVIGATION_WIDGET', this.renderName || this.widgetType)
      const bannerImpressionData = this.getBannerImpressionData(prm, index + 1)
      let eventPaylod = {
        creative_name: bannerImpressionData.creative_name ? bannerImpressionData.creative_name : 'NA',
        creative_slot: bannerImpressionData.creative_slot || bannerImpressionData.creative_slot === 0 ? bannerImpressionData.creative_slot : 'NA',
        promotion_id: bannerImpressionData.promotion_id ? bannerImpressionData.promotion_id : 'NA',
        creative_image: bannerImpressionData && bannerImpressionData.creative_img ? bannerImpressionData.creative_img : 'NA',
        promotion_name: bannerImpressionData.promotion_name ? bannerImpressionData.promotion_name : 'NA',
        promotion_tab: this.webcategory || 'NA'
      }
      this.$store.dispatch('ECOMMERCE_EVENT', { eventName: 'select_promotion', payload: eventPaylod })
      this.$store.commit('GTM_EVENT', { eventName: 'select_promotion', payload: eventPaylod })
      this.$store.commit('MOENGAGE_EVENT', {eventName: 'HOMEPAGE-SECTION',
        payload: {
          Section_Name: this.renderName || '',
          Section_Index: index,
          Product_Category: prm.category || '',
          Product_Name: '',
          Product_ID: prm.id || '',
          Product_Price: '',
          Product_Artist: '',
          ProductImage_URL: prm.image,
          Product_URL: prm.is_pdp ? this.getProductUrl(true, prm.product_slug, prm.gender) : this.getProductUrl(false, prm.url, ''),
          GENDER: gender
        }}
      )
      if (prm && prm.is_pdp || prm.product_slug) {
        this.$router.push(`/product/${prm.product_slug}?gte=${prm.gender ? 2 : 1}`)
      } else if (prm && !prm.is_pdp) {
        this.$router.push(prm.url)
      }
    },
    getBannerImpressionData (obj, index) {
      return {
        promotion_id: obj.id || '',
        promotion_name: obj.promotion_name || this.renderName || '',
        creative_name: obj.product_type || obj.url || this.renderName || '',
        creative_slot: index || 'NA',
        creative_img: obj.image || 'NA',
        currency: 'INR'
      }
    },
    getRecommNewArrivalsData () {
      if (!this.bannerPlaceHolderForRecommNewArrivals) {
        this.$store.dispatch('GET_RECOMMENDED_NEW_ARRIVALS_DATA')
      }
    },
    getProductUrl,
    getBannerImage (img) {
      return img && img.length && img.includes('https://img.thesouledstore.com') ? img.replace('https://img.thesouledstore.com', 'https://prod-img.thesouledstore.com') : img
    }
  },
  computed: {
    ...mapGetters(['isExclusive', 'recommNewArrivalsData', 'authStatus', 'bannerPlcaeHolderData', 'tatvicProductImpression', 'webcategory']),
    getDescription: function () {
      if (this.renderData && this.renderData.length > 1) {
        return this.renderData[this.renderData.length - 1][3]
      }
    },
    shouldAutoPlay () {
      if (this.enableHorizontalScrollTheUltimateSummer && this.renderName === 'THE ULTIMATE SUMMER LOOK' || this.enableHorizontalScrollMostLovedProduct && this.renderName === 'MOST LOVED PRODUCT') {
        return true
      } else {
        return false
      }
    },
    bannerPlaceHolderForRecommNewArrivals: function () {
      return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.product_type.toLowerCase() === 'HIDE_RECOMM_NEW_ARRIVALS_WEB'.toLowerCase())
    },
    enableHorizontalScrollTheUltimateSummer: function () {
      return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'Home Screen Page'.toLowerCase() && bannerData.product_type.toLowerCase() === 'AUTO_PLAY_THE_ULTIMATE_SUMMER'.toLowerCase())
    },
    enableHorizontalScrollMostLovedProduct: function () {
      return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'Home Screen Page'.toLowerCase() && bannerData.product_type.toLowerCase() === 'AUTO_PLAY_MOST_LOVED_PRODUCT'.toLowerCase())
    },
    isRecommendedNewArrivals: function () {
      return !this.bannerPlaceHolderForRecommNewArrivals && this.recommNewArrivalsData && this.recommNewArrivalsData.length && this.renderData && this.renderData.length
    }
  },
  watch: {
    authStatus () {
      this.getRecommNewArrivalsData()
    }
  },
  mounted () {
    this.newArrivalShimmerLoading = this.renderData.map(() => true)
    this.getRecommNewArrivalsData()
    if (this.tatvicProductImpression && this.tatvicProductImpression.data.length) {
      // this.$store.dispatch('ECOMMERCE_EVENT', {eventName: 'view_item_list',
      //   payload: {
      //     ecommerce: {
      //       'items': [
      //         ...this.tatvicProductImpression.data
      //       ]
      //     }
      //   }
      // })
    }
  }
}
</script>

<style scoped>
  .newarrivalcard {
    margin: 1rem 0 0.2rem 0;
    min-height: 422px;
  }
  .newarrivalcard .title {
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.24;
    letter-spacing: normal;
    text-align: center;
    color: #282c3f;
    text-transform: uppercase;
    margin: 0;
  }

.custom-slide {
  flex: 0 0 auto;
  width: calc(100% / 1.3);
}

  .newarrivalcard__title-cont {
    /* margin-bottom: 2rem; */
    margin-bottom: 1.5rem;
    margin-top: 1.5rem !important;
  }
  .newarrivalcard__title-cont .descrition {
    font-size: 1.6rem;
    line-height: 1.26;
    letter-spacing: normal;
    text-align: center;
    color: #525964;
    margin: 0;
  }
  @media screen and (max-width: 768px) {
    .newarrivalcard .title {
      font-size: 1.13rem;
    }
    .newarrivalcard {
      margin: 0;
      padding: 1rem 0rem;
      box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
      background-color: #ffffff;
      min-height: 267px;
    }
    .newarrivalcard__title-cont {
      margin-bottom: .6rem;
      margin-top: 0rem !important;
    }
    .img-card {
      border-radius: .3rem;
      padding: 4px;
    }
    .newarrivalcard__title-cont .descrition {
      font-size: 1rem;
    }
  }
</style>



// WEBPACK FOOTER //
// NewArrivalsCard.vue?2746e0f0